import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 16V8l-4 4zm4-9h10v2H11zm0 4h10v2H11zm0 4h10v2H11zm-8 4h18v2H3zM3 3h18v2H3z"
}), 'FormatIndentDecreaseTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatIndentDecreaseTwoTone.js
// module id = 3843
// module chunks = 2